var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-group"},_vm._l((_vm.tags),function(tag){return _c('tag-item',{key:tag.id,attrs:{"tag":tag}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }